<div class="col-12 col-sm-12 col-md-12 col-lg-12 boxstyle">
        <div class="row whitebox">
            <div class="bold fs-20 txt-black1 curPtr" (click)="goToReportTab()">Reports ></div>
            <div class="bold fs-20 txt-red">&nbsp;{{reportType}}</div>
        </div>
        <div class="row px-2 pt-3">
            <label class="bold fs-20 txt-black1">Report Details</label>
        </div>
        <div>
            <div class="row p-2">
                <div class="col-sm-3 col-md-3 col-lg-3 col-xl-3 col-3">
                    <label class="regular fs-16 txt-clr-grey">OVR Code</label>
                    <ng-select placeholder="Select" [(ngModel)]="agentID">
                        <ng-option *ngFor="let item of agentcodedata" [value]="item.id">{{item.agentCode}}</ng-option>
                    </ng-select>
                </div>
            </div>
            <div class="row p-2">
                <div class="col-sm-3 col-md-3 col-lg-3 col-xl-3 col-3">
                    <label class="regular fs-16 txt-clr-grey">Statement Date</label>
                    <ng-select placeholder="Select" [(ngModel)]="statement_date">
                        <ng-option *ngFor="let item of StatementDate" [value]="item.statmentDate">{{item.statmentDate}}</ng-option>
                    </ng-select>
                </div>
            </div>
            <div class="row p-2">
                <div class="col-sm-3 col-md-3 col-lg-3 col-xl-3 col-3">
                    <label class="regular fs-16 txt-clr-grey">Report Format</label>
                    <ng-select placeholder="Select" [(ngModel)]="report_format">
                        <ng-option *ngFor="let item of ReportFormat" [value]="item.type">{{item.name}}</ng-option>
                    </ng-select>
                </div>
            </div>
            <div class="row p-2">
                <div class="col-sm-3 col-md-3 col-lg-3 col-xl-3 col-3 button-alignment">
                    <button type="button" class="fs-16 regular download-button" (click)="download()">Download Report</button>
                </div>
            </div>
        </div>
</div>